export const Status = {
  ALL: "success",
  SOME: "ongoing",
  NONE: "errorRed",
};
